<style scoped lang="less">
  input{
    position: absolute;
    left: 0 ;
    width: 100%;
    height: 100%;
    top: 0 ;
    opacity:  0;
    z-index: 1;
  }
  .imgs-wrap{
      padding: 30px  20px;
      box-sizing: border-box;
      margin-top: 10px;
      >img{
         width: 116px;
         height: 114px;
         margin-right: 10px;
       }
      .img-out{
        display: inline-block;
        position: relative;
        width: 116px;
        height: 114px;
        margin-right: 20px;
        margin-top: 30px;
        .close-btn{
          position: absolute;
          width: 35px ;
          height: 35px ;
          right: -8px!important;
          top: -15px;
          z-index: 2;
        }
        .img{
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0 ;
          top: 0;
          z-index: 1;
        }
        input{
          position: absolute;
          left: 0 ;
          width: 0;
          height: 0;
          top: 0 ;
          opacity:  0;
          z-index: 1;
        }
      }
  }
</style>
<template>
    <div >
      <slot name="preview">
        <div class="imgs-wrap b_FS-0 edit c_white-bg" v-if="isNeedPreview && previewImages.length" >

          <!--<img  src="https://image.artyears.cn/image/2017-06/547749a9-09aa-4ea5-9ec6-804bd9a4f15b" alt="">-->
          <!--<img  src="https://image.artyears.cn/image/2017-06/547749a9-09aa-4ea5-9ec6-804bd9a4f15b" alt="">-->
          <!--<img  src="https://image.artyears.cn/image/2017-06/547749a9-09aa-4ea5-9ec6-804bd9a4f15b" alt="">-->
          <template v-for="(image, key) in previewImages">
            <!-- eslint-disable-next-line -->
              <!-- <img class="img" :src="image" alt=""> -->
            <!-- <img :src="testImg" alt="tstimg"> -->
            <div class="img-out b-MT-10 c_white-bg" :key="key">
              <img class="img" :src="image" alt="">
              <img @click.self = "giveUpANIamge(key)" class="close-btn" src="@/assets/img/icon/icon-close-small2.png" alt="">
            </div>
          </template>
          <div class="img-out" @click="proxyClickInput" v-if="previewImages.length > 0 && previewImages.length < maxLength && maxLength > 1 ">
            <img class="img" src="@/assets/img/icon/icon-add01.png" alt="">
          </div>
          <!--<div class="img-out" v-if="previewImages.length <4">-->
          <!--<img class="img" src="@/assets/img/icon-add01.png" alt="">-->
          <!--<input ref="fileinput" type="file" accept="image/gif,image/jpg,image/jpeg,image/bmp,image/png" @change ="selectImages($event)" multiple="multiple">-->
          <!--</div>-->
        </div>
        <div class="c_placeholder c_white-bg" v-if="previewImages.length && isNeedPreview " >
          &nbsp;&nbsp;&nbsp;&nbsp;*只允许最多上传{{ maxLength }}张图片
        </div>
        <!--<div @click="addTaskProcess" class="btn-small-primary b-MT-5" >提交</div>-->
      </slot>
      <!-- v-if="previewImages.length < maxLength " -->
      <div @click="proxyClickInput" >
        <slot name="input" >
          <div class="b_block b-LR-10 b-TB-10" v-if="previewImages.length == 0 ">
            <div class="upload-image ">
              <img src="@/assets/img/icon/icon-19.png" alt="">
              <p class="c_placeholder">
                添加图片
              </p>
            </div>
          </div>
        </slot>
      </div>
      <!-- <input style="width: 0;height: 0" ref="fileinput" type="file" accept="image/jpg,image/jpeg,image/bmp,image/png" @change ="selectImages($event)" > -->
      <!-- <form action="/consult/upload" id="domeform" method="post" enctype="multipart/form-data"> -->
      <input  style="width: 44px;height: 38px; z-index: 10;" ref="fileinput" type="file" accept="image/*" @change ="selectImages($event)">
      <!-- </form> -->
      <!-- <input type="file" accept="image/*" @change ="selectImages($event)" placeholder="dianwo"> -->
    <!-- <img :src="testImg" alt="testimg"> -->
    </div>
</template>
<script>
/* eslint-disable */
import upload from '../../common/upload.js'

export default{
  name: 'upload',
  props: {
    maxLength: {
      type: [String, Number],
      default: 1
    },
    isNeedPreview: {
      type: Boolean,
      default: false
    },
    // 限制上传图片大小
    maxSize: {
      type: [String, Number],
      default: 10
    }
  },
  // mixins混入，混入可复用功能
  mixins: [upload],
  methods: {
    proxyClickInput () {
      if (this.previewImages.length >= this.maxLength) {
        return
      }
      this.$refs.fileinput.click()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/imageUpload.vue